import { useNavigate } from 'react-router-dom';
import { LazyPage } from '../components/loadable';
import { useEffect } from 'react';
import { PlaceHolder } from '../components/place-holder';


export { default as HomePage } from './home/home';

export const ThoiKhoaBieuPage = LazyPage(import('./danh-muc/thoi-khoa-bieu'));
export const ThoiKhoaBieuChiTietPage = LazyPage(import('./thoi-khoa-bieu-chi-tiet'));
export const NoiTruLayout = LazyPage(import('./noi-tru'));
export const DiemDanhHangNgay = LazyPage(import('./diem-danh-hang-ngay'));
export const Tiet = LazyPage(import('./danh-muc/nt_tiet'));
export const Tuan = LazyPage(import('./danh-muc/nt_tuan'));
export const DanhSachCongNoPage = LazyPage(import('./finance/cong-no'));
export const CauHinhDonGiaPage = LazyPage(import('./finance/don-gia'));
export const DiemDanhHangNgayPage = () => {

    const navigate = useNavigate();
    navigate(`../../diem-danh-hang-ngay/diem-danh`)
    useEffect(() => {
        navigate(`../../diem-danh-hang-ngay/diem-danh`)
    }, [])
    return (
        <PlaceHolder line_number={10} />
    );
}


